angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherClassesArchived', function ($http, $log, EventManager, userAccount, api,  DATA_HOST) {
  return {
    templateUrl: 'template.html',
    scope: {},
    link: function (scope, element) {

      var eventManager = new EventManager('teacherClassesArchived', scope);

    }
  }
});
